/**
 * @version 1.0.0
 * @since 1.0.0
 * @author Alex Dinari <alex.dinari@aofl.com>
 */
import {Sdo, storeInstance, state} from '@aofl/store';

/**
 * @type {String}
 * @private
 */
const NAMESPACE = 'download';

/**
 * @extends {Sdo}
 */
class DownloadSdo extends Sdo {
  /**
   * @static
   * @type {String}
   */
  static namespace = NAMESPACE;

  /**
   * @static
   * @type {String}
   */
  @state()
  ddMenuColor = 'gold';
}

/**
 * @type {DownloadSdo}
 */
const downloadSdo = new DownloadSdo();
storeInstance.addState(downloadSdo);

export {
  downloadSdo
};
